import { render, staticRenderFns } from "./channel.container.vue?vue&type=template&id=8b124096&scoped=true&lang=pug"
import script from "./channel.container.vue?vue&type=script&lang=ts"
export * from "./channel.container.vue?vue&type=script&lang=ts"
import style0 from "./channel.container.vue?vue&type=style&index=0&id=8b124096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b124096",
  null
  
)

export default component.exports